<div>
    <ng-content select="ai-button"></ng-content>
</div>
